@if (hasClashes) {
  <div class="clash-banner w-100 mb-3">
    <div class="clash-banner-head">
      <mat-icon class="clash-banner-icon">warning</mat-icon>
      <span class="clash-banner-text">
        {{ clashes().length }} possible clash{{ clashes().length === 1 ? '' : 'es' }} for this time slot.
      </span>
      <button mat-icon-button type="button" (click)="toggle()" [attr.aria-label]="expanded() ? 'Hide clashes' : 'Show clashes'">
        <mat-icon>{{ expanded() ? 'expand_less' : 'expand_more' }}</mat-icon>
      </button>
    </div>
    @if (expanded()) {
      <ul class="clash-list">
        @for (clash of clashes(); track clash.id) {
          <li class="clash-item">
            <span class="clash-tag" [class.clash-tag--location]="clashTypeLabel(clash.clashType) === 'Location'">
              {{ clashTypeLabel(clash.clashType) }}
            </span>
            <span class="clash-when">{{ clashTime(clash) }}</span>
            @if (clashWho(clash)) {
              <span class="clash-who">{{ clashWho(clash) }}</span>
            }
          </li>
        }
      </ul>
    }
    <div class="clash-banner-note">This is only a warning — you can still save.</div>
  </div>
}
